
/* IMPORT */

import Item from './item';

/* PROJECT */

class Project extends Item {

  contextValue = 'project';

}

/* EXPORT */

export default Project;
